import { UI } from 'react-day-picker';

import { BASE_INPUT_SIZE } from '../VBaseInput/variable';
import inputTwStyle from '../VInput/style';
import { joinCn } from '../util';
import type { VDatePickerProps } from './type';

const style = {
  vDatePickerInput: ({ size }: Pick<VDatePickerProps<any>, 'size'>) => {
    return joinCn(inputTwStyle({ size }).input, 'flex-1', 'w-full');
  },

  vDatePickerIcon: ({ size }: Pick<VDatePickerProps<any>, 'size'>) => {
    return joinCn('text-primary-500', {
      'size-4': size === BASE_INPUT_SIZE.SM,
      'size-5.5': size === BASE_INPUT_SIZE.MD,
      'size-6': size !== BASE_INPUT_SIZE.SM && size !== BASE_INPUT_SIZE.MD,
    });
  },

  vDatePickerDayButton({
    isToday,
    outside,
    rangeEnd,
    rangeMiddle,
    rangeStart,
    selected,
  }: {
    isToday: boolean;
    outside: boolean;
    rangeEnd?: boolean;
    rangeMiddle?: boolean;
    rangeStart?: boolean;
    selected?: boolean;
  }) {
    return joinCn(
      'h-10 w-10',
      'text-body-m',
      !rangeStart &&
        !rangeEnd &&
        !rangeMiddle && [
          'rounded-full',
          'hover:shadow-sm',
          'focus:bg-secondary-300 focus:text-white',
        ],
      (rangeStart || rangeEnd) &&
        'w-full bg-secondary-300 font-bold text-white',
      rangeMiddle && 'w-full bg-tertiary-200',
      outside ? 'text-gray-300' : 'text-black',
      selected && 'bg-secondary-300 text-white',
      isToday && 'border border-secondary-300',
    );
  },

  DayPickerCustom: {
    [UI.Root]: joinCn('p-4', 'font-display'),
    [UI.Months]: joinCn('flex flex-col gap-2'),
    [UI.Month]: joinCn('flex flex-col gap-2'),
    [UI.Dropdowns]: joinCn(
      'flex flex-row-reverse items-center justify-between gap-1',
    ),
    [UI.DropdownRoot]: joinCn('flex items-center'),
    [UI.Dropdown]: joinCn(
      'px-4 py-1.5',
      'min-w-10',
      'border border-gray-300',
      'rounded-full',
      'text-center',
      'hover:border-secondary-300',
    ),
    [UI.CaptionLabel]: joinCn('hidden'),
    [UI.Weekday]: joinCn('h-12 w-12 font-normal'),
    [UI.Nav]: joinCn('flex justify-between'),
    [UI.Day]: joinCn('h-12 w-12 text-center'),
  },
} as const;

export default style;
